// extracted by mini-css-extract-plugin
module.exports = {"opening":"_3qedYe0Wditj6NcDzCepNq","opening--active":"_2H9KT9-eCyEuK6JRY_AnVk"};